import { styled } from '@clickcease/cc-client-components-lib'

export const SelectDomainsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const SearchContainer = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '$6',
})

export const LoaderOverlay = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: '$white',
  opacity: 0.5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const DomainTableConatiner = styled('div', {
  padding: '$10 $12',
  width: '644px',
})

export const DomainTable = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  overflowY: 'auto',
  height: '260px',

  '> *:not(:first-child)': {
    borderTop: '1px solid $lightGray',
  },
})

export const DomainTableRow = styled('div', {
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  paddingBlock: '$6',

  variants: {
    isHeader: {
      true: {
        borderBottom: '1px solid $lightGray',
        borderTop: 'none',
      },
    },
  },
})

export const DomainTableCell = styled('div', {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',

  variants: {
    flexStart: {
      true: {
        justifyContent: 'flex-start',
      },
      false: {
        justifyContent: 'flex-end',
      },
    },
    isPadded: {
      true: {
        paddingRight: '34px',
      },
    },
  },
})

export const TooltipWrapper = styled('div', {
  position: 'absolute',
  right: ' -24px',

  svg: {
    color: '$lightGray',
  },
})

export const SetupDomainsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})

export const TooltipPositionWrapper = styled('div', {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
})

export const FooterContainer = styled('div', {
  display: 'flex',
  padding: '$5 $8',
  width: 'calc(100% - 32px)',
  justifyContent: 'flex-end',
  alignItems: 'center',
  alignSelf: 'stretch',
  borderTop: '1px solid $lightGray',

  variants: {
    isTwoIcons: {
      true: {
        justifyContent: 'space-between',
      },
    },
  },
})

export const DomainSelectionContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$6',
  paddingInline: '$11',
  paddingTop: '$4',
  variants: {
    isNewTagImplementation: {
      true: {
        width: '100%',
        paddingTop: '$4',
      },
    },
  },
})

export const MessageContainer = styled('div', {
  padding: '$10 $12',
  width: '510px',
  variants: {
    isNewTagImplementation: {
      true: {
        padding: '0px',
      },
    },
  },
})

export const MethodSelectionContainer = styled('div', {
  padding: '$10 $12',
})

export const HoriontalSpacerWithBorder = styled('div', {
  borderTop: '1px solid $lightGray',
  marginBlock: '$8',
  width: '100%',
})
